export default {
	categoriesLabel: "Kategorier",
	emojiUnsupportedMessage: "Din browser understøtter ikke farve-emoji.",
	favoritesLabel: "Favoritter",
	loadingMessage: "Indlæser…",
	networkErrorMessage: "Kunne ikke indlæse emoji.",
	regionLabel: "Emoji-vælger",
	searchDescription: "Når søgeresultater er tilgængelige, tryk op eller ned for at vælge og enter for at bekræfte.",
	searchLabel: "Søg",
	searchResultsLabel: "Søgeresultater",
	skinToneDescription: "Når udvidet, tryk op eller ned for at vælge og enter for at bekræfte.",
	skinToneLabel: "Vælg en hudfarve (nuværende {skinTone})",
	skinTonesLabel: "Hudfarver",
	skinTones: [
		"Standard",
		"Lys",
		"Medium-Lys",
		"Medium",
		"Medium-Mørk",
		"Mørk"
	],
	categories: {
		custom: "Brugerdefineret",
		"smileys-emotion": "Smileys og emoticons",
		"people-body": "Mennesker og krop",
		"animals-nature": "Dyr og natur",
		"food-drink": "Mad og drikke",
		"travel-places": "Rejser og steder",
		activities: "Aktiviteter",
		objects: "Objekter",
		symbols: "Symboler",
		flags: "Flag"
	}
}
